import React from 'react';
import { Text } from '@fiverr-private/typography';
import { Divider, Stack, Center } from '@fiverr-private/layout_components';
import { getProMenusCopiesConfig } from '@fiverr-private/layout_menus';
import { ProSellerL2Icon, ProServicesL2Icon } from '@fiverr-private/visuals';
import { getBQData } from '../../../../utils/business/bi-utils';
import Link from '../../../Links/Link';
import { buildLinkHref } from '../../../../utils/buildLinkHref';
import { HEADER_POPUP_SOURCE } from '../../../../constants';

export const DefaultMenu = () => {
    const { pro_dropdown } = getProMenusCopiesConfig();

    return (
        <Stack direction="column" gap="0" paddingY="2" paddingX="6">
            {pro_dropdown.items.map((item, index) => (
                <>
                    <LinkItem item={item} key={item.key} />
                    {/* Don't show divider after the last item */}
                    {index < pro_dropdown.items.length - 1 && <Divider marginY="4" />}
                </>
            ))}
        </Stack>
    );
};

const LinkItem = ({ item }: any) => {
    const itemKeyToProp = {
        offer_services: {
            icon: <ProSellerL2Icon size="md" />,
            bq: getBQData({ type: 'i_am_freelancer' }),
            mp: {
                eventName: 'Fiverr logged-out header - Pro - Seller Clicked',
            },
        },
        sourcing: {
            icon: <ProServicesL2Icon size="md" />,
            bq: getBQData({ type: 'hire_freelancer' }),
            mp: {
                eventName: 'Fiverr logged-out header - Pro - Buyer Clicked',
            },
        },
    };

    const link = buildLinkHref({ link: item.link, source: HEADER_POPUP_SOURCE });

    return (
        <Stack paddingX="4" paddingY="3">
            <Link
                mpData={itemKeyToProp[item.key].mp}
                bigQueryData={itemKeyToProp[item.key].bq}
                target="_blank"
                href={link}
            >
                <Stack gap="6">
                    <Center flexShrink="0">{itemKeyToProp[item.key].icon}</Center>
                    <Stack direction="column" gap="0">
                        <Text size="b_sm" fontWeight="bold">
                            {item.text}
                        </Text>
                        <Text size="b_sm">{item.description}</Text>
                    </Stack>
                </Stack>
            </Link>
        </Stack>
    );
};
